import angular from 'angular';

(function() {
    'use strict';

    angular.module('app.core').component('kissAccordion', {
        bindings: {
            title: '@',
            glyphiconClasses: '@',
            addLabel: '@',
            addHidden: '<',
            onAdd: '&',
            opened: '<' // True par défaut. Permet de choisir si l'accordeon est ouvert lors du chargement
        },
        controller: AccordionController,
        templateUrl: require('./accordion.html'),
        transclude: true
    });

    function AccordionController(/*$scope, $element, $attrs*/) {
        var ctrl = this;

        ctrl.$onInit = function() {
            if (ctrl.opened == null) {
                // Ouvert par defaut
                ctrl.opened = true;
            }

            // "Critères de recherche" par defaut
            if (angular.isUndefined(ctrl.title)) {
                ctrl.title = 'SEARCH_HEADER';
            }
        };

        ctrl.handleAdd = function() {
            ctrl.onAdd();

            // Hack pour éviter le changement d'ouverture (e.stopPropagation() ne fonctionne pas ?)
            ctrl.opened = !ctrl.opened;
        };
    }
})();
